<template>
  <el-autocomplete
    class="select-input-auto-main"
    v-model="data.major"
    :debounce="10"
    :hide-loading="true"
    label="major"
    value-key="name"
    :fetch-suggestions="remoteMethod"
    placeholder="请输入"
    @select="select"
    @input="select(value)"
    :select-when-unmatched="true">

    <template slot-scope="{ item }">
      <p v-html="item.highlight"></p>
    </template>

  </el-autocomplete>
</template>
<script>
import api from '@/api';
import { mapState } from 'vuex'
export default {
  props: {
    data: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      run: null,
      options: [],
      value: {
        name: ''
      },
      list: [],
      loading: false,
    }
  },
  computed: {
    ...mapState('editor', [ 'currentInfo' ])
  },
  watch: {},
  mounted() {
  },
  methods: {
    async remoteMethod(query, cb) {
      let params = {
        keyword: query
      };
      try {
        let res = await api.cvsEditor.majorAutoCompletions(params);
        if (res.code === 1000) {
          cb && cb((res.data || []));
          this.checkInput(res.data)
        }
      } catch (e) {
        console.log('majorAutoCompletions error:', e)
      }
    },
    select(data) {
      this.currentInfo.data.major_id = data.id
      // clearTimeout(this.run)
      // // this.$emit('select', '你是我的小丫小苹果')
      // const timer = setTimeout(() => {
      //   let value = {}
      //   if (data.name) {
      //     value = data
      //   } else {
      //     value = {
      //       name: data.value
      //     }
      //   }
      //   this.value = value
      //   this.$emit('select', value)
      // }, 300)
      // this.run = timer
      // clearTimeout(this.run);
      // this.run = setTimeout(() => {
      //   let value = {};
      //   if (data.name) {
      //     value = data;
      //   }
      //   else {
      //     value = {
      //       name: data.value || ''
      //     }
      //   }
      //   this.value = value;
      //   this.$emit('select', value);
      // }, 300);
    },
    // 检查输入的是否与自动补全内容完全一样，如果一样，同步id
    checkInput (list) {
      if (!list) return false
      let res = null
      res = list.filter(item => item.name === this.data.major && this.data.major)
      if (res && res.length > 0) {
        this.currentInfo.data.major_id = res[0].id
      } else {
        this.currentInfo.data.major_id = null
      }
    }
  }
}
</script>
<style lang="scss" scoped>

  .select-input-auto-main {
    width: 100%;
  }

  ::v-deep .es-highlighter {
    color: #FF6644;
  }
</style>
